import DisclosureEx from "@components/DisclosureEx";
import React, {useState} from "react";
import {useFormContext} from "react-hook-form";
import CheckboxEx from "@components/wrapperComponents/CheckboxEx";
import {IconPlus, IconTool} from "@tabler/icons-react";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import NuovaDistribuzione from "./NuovaDistribuzione";
import {FPNetDate} from "@commons/types";
import {PresenzeFormValues} from "../FormDataUpdater";
import {Updater} from "use-immer";

interface OpzioniGiornataProps {
    dtGiornata: FPNetDate,
    updateDefaultValues: Updater<PresenzeFormValues>
}

const OpzioniGiornata: React.FC<OpzioniGiornataProps> = ({dtGiornata, updateDefaultValues}) => {

    const {control, getValues} = useFormContext<PresenzeGiornataPlusRecord>();

    const [openDistribPanel, setOpenDistribPanel] = useState<boolean>(false);

    return (
        <DisclosureEx accordionColor="bg-[#235f6a] hover:bg-[#1b4952] text-white"
                      accordionTitle="Opzioni di calcolo" icon={<IconTool className="w-4 h-4"/>} accordionState={false}>
            <div className="inline-flex w-full">
                <div className="basis-2/4 inline-flex">
                    {/*--{getValues('pausaFlex').toString()}--*/}
                    <CheckboxEx name="pausaFlex" label="Pausa flessibile attiva" divClassName="basis-1/2" control={control}
                                onClick={() => updateDefaultValues(draft => {
                                    draft.pausaFlex = !(getValues('pausaFlex')); //TODO sistemare - al click su calcola viene resettato!
                                    PresenzeGiornataPlusRecord.resetAnomalia(draft);
                                })}/>
                    <CheckboxEx name="qualificaEccNC" label="Qualifica eccedenti non computabili" divClassName="basis-1/2" control={control}
                                onClick={() => updateDefaultValues(draft => {
                                    draft.qualificaEccNC = !(getValues('qualificaEccNC')); //TODO sistemare - al click su calcola viene resettato!
                                    PresenzeGiornataPlusRecord.resetAnomalia(draft);
                                })}/>
                </div>
            </div>
            <div className="w-full mt-3">
                <button type="button" className="btnPrimary p-1.5 sm:p-2" onClick={() => setOpenDistribPanel(true)} disabled={openDistribPanel}>
                    <IconPlus className="size-4 sm:size-5"/>&nbsp;Distribuzione
                </button>
            </div>

            {openDistribPanel && <NuovaDistribuzione dtGiornata={dtGiornata} onCancel={() => setOpenDistribPanel(false)}/>}

        </DisclosureEx>
    )
}
export default OpzioniGiornata;